import { render, staticRenderFns } from "./projectGroup.vue?vue&type=template&id=0f614f1c&scoped=true&"
import script from "./projectGroup.vue?vue&type=script&lang=js&"
export * from "./projectGroup.vue?vue&type=script&lang=js&"
import style0 from "./projectGroup.vue?vue&type=style&index=0&id=0f614f1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f614f1c",
  null
  
)

export default component.exports